module.exports = __webpack_public_path__ + "img/mapaClube.43c7fd00.jpeg";